module.exports = __webpack_public_path__ + "img/ANANYA MA'AM.393d0623.jpg";